import { render, staticRenderFns } from "./DragFileInput.vue?vue&type=template&id=a891680e&scoped=true&"
import script from "./DragFileInput.vue?vue&type=script&lang=js&"
export * from "./DragFileInput.vue?vue&type=script&lang=js&"
import style0 from "./DragFileInput.vue?vue&type=style&index=0&id=a891680e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a891680e",
  null
  
)

export default component.exports